import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { DownloadByTemplateButton, type DownloadTemplateSelection } from '@/entities/download-template';
import { useDownloadExpertReport } from '@/entities/expert-report';

type Props = {
  conversationId: number;
  expertReportId: number;
};

export const DownloadExpertReportButton: FC<Props> = ({ conversationId, expertReportId }) => {
  const { t } = useTranslation(['dialogs']);
  const { mutate: download, isPending } = useDownloadExpertReport();

  const handleDownload = (selection: DownloadTemplateSelection) => {
    download({ conversationId, expertReportId, ...selection });
  };

  return (
    <DownloadByTemplateButton
      label={t('dialogs:expertReport.downloadReport')}
      entityType="EXPERT_REPORT"
      onDownload={handleDownload}
      isPending={isPending}
    />
  );
};
